export default __webpack_public_path__ + "static/media/support-phone.11181c7f.svg";